<ng-container *ngIf="Isopen">
  <div id="MsgLoading">
    <div id="Icon"></div>
  </div>
</ng-container>
